// extracted by mini-css-extract-plugin
export default {"box":"IndividualFilter_box__Y05Nl","activeChip":"IndividualFilter_activeChip__0nzCE","chip":"IndividualFilter_chip__t4ig7"};